import { render, staticRenderFns } from "./MicroBar.vue?vue&type=template&id=4d343fca&scoped=true&"
import script from "./MicroBar.vue?vue&type=script&lang=ts&"
export * from "./MicroBar.vue?vue&type=script&lang=ts&"
import style0 from "./MicroBar.vue?vue&type=style&index=0&id=4d343fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d343fca",
  null
  
)

export default component.exports